import React from "react";
import "./Footer.scss";
import { Link } from "react-router-dom";
import { Link as LinkExternal } from "@bwevents/components";
import logo from "../../assets/logo-white.png";
import logoInstagram from "../../assets/instagram.png";
import logoYoutube from "../../assets/youtube.png";
import logoLinkedin from "../../assets/linkedin.png";

export default function Footer() {
  const items = [
    {
      label: "Services",
      items: [
        {
          label: "On-site event tech management",
          link: "https://bweventstech.com/on-site-event-tech-management/",
        },
        {
          label: "Event Tech consulting",
          link: "https://bweventstech.com/event-tech-consulting/",
        },
        {
          label: "Platform management ＆ implementation",
          link: "https://bweventstech.com/platform-management-and-implementation/",
        },
        {
          label: "Custom solutions ＆ development",
          link: "https://bweventstech.com/custom-solutions-development/",
        },
      ],
    },
    {
      label: "Quick Links",
      items: [
        {
          label: "Privacy and Terms",
          link: "https://bweventstech.com/privacy-and-terms/",
        },
        {
          label: "Contact",
          link: "https://bweventstech.com/contact/",
        },
        {
          label: "About",
          link: "https://bweventstech.com/about/",
        },
      ],
    },
  ];

  return (
    <footer>
      <div className="bw-event-container">
        <div className="bw-event-row">
          <div className="bw-event-col">
            <Link to="/" className="bw-event-logo">
              <img src={logo} alt="Event Tech" />
            </Link>
            <p>
              BW Events Tech provides event technology consulting,
              configuration, customization, and creative implementation.
            </p>
          </div>
          <div className="bw-event-col">
            <div className="bw-event-row">
              {items.map((menu, key) => (
                <div className="bw-event-col" key={key + menu.label}>
                  <p>{menu.label}</p>
                  <ul>
                    {menu.items.map((submenu, subkey) => (
                      <li key={subkey + menu.label + submenu.label} className="bw-event-item-footer">
                        <LinkExternal href={submenu.link}>
                          {submenu.label}
                        </LinkExternal>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
          <div className="bw-event-col">
            <p>Contact</p>

            <div className="bw-event-socials">
              <div className="social">
                <LinkExternal href="https://instagram.com/bweventstech">
                  <img src={logoInstagram} alt="bweventstech" />
                </LinkExternal>
              </div>
              <div className="social">
                <LinkExternal href="#">
                  <img src={logoYoutube} alt="bweventstech" />
                </LinkExternal>
              </div>
              <div className="social">
                <LinkExternal href="https://www.linkedin.com/company/bw-events-llc/">
                  <img src={logoLinkedin} alt="bw-events-llc" />
                </LinkExternal>
              </div>
            </div>
            <LinkExternal href="mailto:info@bweventstech.com" className="link">
              info@bweventstech.com
            </LinkExternal>
          </div>
        </div>
      </div>
      <div className="bw-event-copyright">
        <div className="bw-event-container">
          <p>© 2023 BW Events Tech. All rights reserved</p>
        </div>
      </div>
    </footer>
  );
}
